import { Ref, forwardRef, useImperativeHandle, useState } from "react";
import { WalletRead, MyWalletService, WalletTransfer } from "@/domains/wallet";
// components
import { Button, Form, Input, Modal } from "antd";
import { t } from "i18next";

interface TransferModalProps {
  onTransfer: () => void;
}

export interface TransferModalRef {
  open: (wallet: WalletRead) => void;
}

export const TransferModal = forwardRef(
  ({ onTransfer }: TransferModalProps, ref: Ref<TransferModalRef>) => {
    const [showing, setShowing] = useState(false);

    const [wallet, setWallet] = useState<WalletRead>();

    const [form] = Form.useForm<WalletTransfer>();

    const handleConfirm = async () => {
      if (!wallet) return;

      const formValue = await form.validateFields();

      try {
        await MyWalletService.transfer(wallet.id, formValue).run();
        setShowing(false);
        onTransfer();
      } catch (e) {
        console.log(e);
      }
    };

    const handleCancel = () => {
      setShowing(false);
    };

    useImperativeHandle(
      ref,
      () => {
        const open = (_wallet: any) => {
          form.resetFields();

          form.setFieldsValue({
            amount: "",
            address: "",
            note: "",
          });

          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          setWallet(_wallet);

          setShowing(true);
        };

        return { open };
      },
      [form]
    );

    return (
      <Modal
        title={t("domains.Wallet.transfer")}
        open={showing}
        footer={[
          <div className="flex jc:end gap:8" key="footer">
            <Button key="back" onClick={handleCancel}>
              {t("systems.Action.cancel")}
            </Button>
            <Button key="submit" type="primary" onClick={handleConfirm}>
              {t("systems.Action.submit")}
            </Button>
          </div>,
        ]}
        onCancel={handleCancel}
      >
        <Form className="mt:16" form={form} labelCol={{ span: 6 }}>
          <Form.Item
            label={t("domains.Wallet.transferAmount")}
            name="amount"
            rules={[
              {
                required: true,
                message: t("systems.Error.cannotBeEmpty", {
                  field: t("domains.Wallet.transferAmount"),
                }),
              },
            ]}
          >
            <Input
              type="number"
              placeholder={t("systems.Placeholder.pleaseInput", {
                field: t("domains.Wallet.transferAmount"),
              })}
            />
          </Form.Item>

          <Form.Item
            label={t("domains.Wallet.transferAddress")}
            name="address"
            rules={[
              {
                message: t("systems.Error.cannotBeEmpty", {
                  field: t("domains.Wallet.transferAddress"),
                }),
              },
            ]}
          >
            <Input
              placeholder={t("systems.Placeholder.pleaseInput", {
                field: t("domains.Wallet.transferAddress"),
              })}
            />
          </Form.Item>

          <Form.Item label={t("domains.Wallet.transferNote")} name="note">
            <Input
              placeholder={t("systems.Placeholder.pleaseInput", {
                field: t("domains.Wallet.transferNote"),
              })}
            />
          </Form.Item>
        </Form>
      </Modal>
    );
  }
);
